export default {
    PaymentOperationID: 1,
    CategoryId: 0,
    PaymentTypeId: 0,
    CashId: 0,
    PaymentAccountId: 0,
    Sum: 0,
    BankCommission: 0,
    CurrencyId: 1,
    AccountNumber: '',
    PaymentDate: '',
    DocumentNumber: '',
    Comment: '',
    PaymentDetails: [],

    loading: false,
}